import { DependentGridList } from "./dependent-grid";
import { PassEncryption } from "./encryption";
import { ResourceLink } from "./resource-link";

export class CheckoutDocuments {
    documents: ResourceLink[];

    constructor() {
        this.documents = new Array<ResourceLink>();
    }
}

export class CheckoutDependents {
    requiredMemberSSN: boolean;
    dependents: DependentGridList[];

    constructor() {
        this.requiredMemberSSN = false;
        this.dependents = new Array<DependentGridList>();
    }
}

export class CheckoutDependentsPayload {
    checkoutDependents: CheckoutDependent[];

    constructor() {
        this.checkoutDependents = new Array<CheckoutDependent>();
    }
}

export class CheckoutDependent {
    dependentID: number;
    sSN: string;

    constructor() {
        this.dependentID = 0;
        this.sSN = '';
    }
}

export class CheckoutMemberSSN {
    sSN: string;
}

export class CheckoutSurcharge {
    disclaimerText: string;
    coverageDetails: CheckoutSurchargeDetail[];

    constructor() {
        this.disclaimerText = null;
        this.coverageDetails = new Array<CheckoutSurchargeDetail>();
    }
}

export class CheckoutSurchargeDetail {
    coverageID: number;
    alternateDescription: string;

    constructor() {
        this.coverageID = 0;
        this.alternateDescription = null;
    }
}

export class CheckoutSurchargePayload {
    coverageDetailID: number;

    constructor() {
        this.coverageDetailID = 0;
    }
}

export interface CheckoutSpousalExclusion {
    disclaimerText: string;
    warningText: string;
    memberBenefits: MemberBenefitDetail[];
}

export interface MemberBenefitDetail {
    memberBenefitID: number;
    benefitName: string;
    effectiveOn: string;
}

export class CheckoutExclusionPayload {
    memberBenefitElections: MemberBenefitCriteria[];

    constructor() {
        this.memberBenefitElections = new Array<MemberBenefitCriteria>();
    }
}

export class MemberBenefitCriteria {
    memberBenefitID: number;
    terminateSpouse: string;

    constructor() {
        this.memberBenefitID = 0;
        this.terminateSpouse = null;
    }
}

export interface WizardCoverageSummary {
    coverageSummaryItems: CoverageSummaryItem[];
    totalDeduction: string;
}

export interface CoverageSummaryItem {
    benefit: string;
    tier: string;
    employeeDeduction: number;
    frequency: string;
    summary: string;
}

export interface CheckoutFinalize {
    showOTPCode: boolean;
    showSignature: boolean;
    homeEmail: string;
    memberPhone: string;
    showVOYAEoi: boolean;
}

export class CheckoutFinalizePayload {
    checkoutMethod: string;
    email: string;
    phoneNumber: string;
    oTPCode: string;
    callerID: string;
    agentPassword: string;
    passEncryption: PassEncryption;

    constructor() {
        this.checkoutMethod = null;
        this.email = null;
        this.phoneNumber = null;
        this.oTPCode = null;
        this.callerID = null;
        this.agentPassword = null;
        this.passEncryption = new PassEncryption()
    }
}

export interface CheckoutWaiveDocument {
    waiveBenefitHTMLDisclaimer: string;
}

export interface CheckoutAdminEvent {
    expirationInstruction: string;
    gIInstruction: string;
    showGIInstruction: boolean;
}

export interface CheckoutComplete {
    hasAnyEnrollmentOptions: boolean;
    hasMoreThanOneCheckoutFinishedOptionAvailable: boolean;
    title: string;
    message: string;
    checkoutItems: CheckoutItem[];
}

export interface CheckoutItem {
    mode: string;
    messageForDisplay: string;
}

export class CheckoutVerificationCode {
    userId: string;
    code: string;
    checkoutMethod: string;
    email: string;
    phoneNumber: string;

    constructor() {
        this.userId = null;
        this.code = null;
        this.checkoutMethod = null;
        this.email = null;
        this.phoneNumber = null;
    }
}